var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomePlayButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-HomePlayButton"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HomePlayButton",
    clipPath: "url(#clip-HomePlayButton)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_548",
    "data-name": "Ellipse 548",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(5 5)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-pause",
    "data-name": "Icon ionic-ios-pause",
    transform: "translate(7.103 7.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M12.593,22.743H9.4a.4.4,0,0,1-.4-.4V7.15a.4.4,0,0,1,.4-.4h3.189a.4.4,0,0,1,.4.4V22.343A.4.4,0,0,1,12.593,22.743Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M24.968,22.743H21.78a.4.4,0,0,1-.4-.4V7.15a.4.4,0,0,1,.4-.4h3.189a.4.4,0,0,1,.4.4V22.343A.4.4,0,0,1,24.968,22.743Z",
    transform: "translate(-3.579 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePlayButton);
export default __webpack_public_path__ + "static/media/HomePlayButton.1b03f39cbc1f09c42cc67769eda869ed.svg";
export { ForwardRef as ReactComponent };